/**
 * Card (design-system §7 · Card): superficie, borde 1 px, radio lg, padding 20 px (Admin),
 * `shadow-1`. La variante clicable eleva a `shadow-2` en 120 ms.
 */
import { cn } from '../../lib/cn';

import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}

export function Card({ className, interactive, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-fm-lg border border-fm-border bg-fm-surface p-fm-5 shadow-fm-1',
        interactive &&
          'cursor-pointer transition-shadow duration-fm-fast ease-fm-standard hover:shadow-fm-2 motion-reduce:transition-none',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mb-fm-4 flex items-start justify-between gap-fm-4', className)}
      {...props}
    />
  );
}

export function CardTitle({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLHeadingElement> & { children: ReactNode }) {
  return (
    <h2 className={cn('font-display text-fm-lg font-semibold text-fm-text', className)} {...props}>
      {children}
    </h2>
  );
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-fm-sm text-fm-text-secondary', className)} {...props} />;
}

export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-fm-sm text-fm-text', className)} {...props} />;
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mt-fm-5 flex justify-end gap-fm-2', className)} {...props} />;
}
